<div class="search" role="search">
  <mat-icon class="search__icon" fontSet="material-icons-outlined">search</mat-icon>
  <label class="sr-only" for="hx-search">Search radio stations</label>
  <input
    id="hx-search"
    class="search__input"
    type="text"
    placeholder="Search stations, genres, countries…"
    autocomplete="off"
    spellcheck="false"
    [ngModel]="text()"
    (ngModelChange)="search($event)"
  />
  @if (text()) {
    <button type="button" class="search__clear" (click)="clear()" aria-label="Clear search">
      <mat-icon>close</mat-icon>
    </button>
  }
</div>
